export const pgvEventReport = function (
  tag,
  virtualDomain = 'nintendoswitchcn.qq.com'
) {
  if (typeof window.pgvSendClick === 'function') {
    window.pgvSendClick({
      hottag: tag,
      virtualDomain
    });
  }
};
